module.exports = __webpack_public_path__ + "static/media/adjustable.fb7e7705.png";